import {AfterViewInit, Component, OnInit} from '@angular/core';

import { AuthService } from "../../shared/services/auth.service";
import { pessoasRoute, pessoasModuleName } from "../../recursos-humanos/pessoas/shared/data.service";
import { recursosHumanosRoute, recursosHumanosModuleName } from "../../recursos-humanos/shared/data.service";
import { motoristasModuleName, motoristasRoute } from "../../recursos-humanos/motoristas/shared/data.service";
import { estruturasRoute } from "../../estruturas/shared/data.service";
import { localidadesModuleName, localidadesRoute } from "../../estruturas/localidades/shared/data.service";
import { orgaosRoute, orgaosModuleName } from "../../estruturas/orgaos/shared/data.service";
import { divisoesRoute, divisoesModuleName } from "../../estruturas/divisoes/shared/data.service";
import { bensRoute } from "../../bens/shared/data.service";
import { marcasRoute , marcasModuleName} from "../../bens/marcas/shared/data.service";
import { categoriasRoute, categoriasModuleName } from "../../bens/categorias/shared/data.service";
import {
    veiculosRoute, veiculosModuleName, aeronavesRoute,
    aeronavesModuleName, embarcacoesRoute, embarcacoesModuleName, equipamentosRoute, equipamentosModuleName,
    maquinarioRoute, maquinarioModuleName, outrosRoute, outrosModuleName, frotasRoute
} from "../../bens/frotas/shared/data.service";
import { orgaoTiposRoute, orgaoTiposModuleName } from "../../estruturas/orgaos/orgao-tipos/shared/data.service";
import { almoxarifadoRoute } from "../../almoxarifado/shared/data.service";
import { medidasRouter, medidasModuleName } from "../../almoxarifado/medidas/shared/data.service";
import { contasRoute } from "../../contas/shared/data.service";
import { contasContabeisRouter, contasContabeisModuleName } from "../../contas/conta-contabil/shared/data.service";
import { gruposMateriaisModuleName, gruposMateriaisRouter } from "../../almoxarifado/grupos-materiais/shared/data.service";
import { materialRouter, materialTitle, materiaisRouter } from "../../almoxarifado/materiais/material/shared/data.service";
import {UsuarioService} from "../../recursos-humanos/usuarios/shared/usuario.service";

@Component({
    template: require('./gestao.component.html'),
    styles: [require('./gestao.component.css')]
})
export class GestaoComponent implements OnInit, AfterViewInit {
    user: any = {};

    rhRoute: string = recursosHumanosRoute;
    pessoasRoute: string = pessoasRoute;
    rhModule: any = recursosHumanosModuleName;
    pessoasModule: any = pessoasModuleName;
    motoristasModule: any = motoristasModuleName;
    motoristasRoute: string = motoristasRoute;

    estruturasRoute: string = estruturasRoute;
    localidadesRoute: string = localidadesRoute;
    localidadesModule: any = localidadesModuleName;
    orgaosRoute: string = orgaosRoute;
    orgaosModule: any = orgaosModuleName;
    divisoesRoute: string = divisoesRoute;
    divisoesModule: any = divisoesModuleName;
    orgaoTiposRoute: string = orgaoTiposRoute;
    orgaoTiposModule: any = orgaoTiposModuleName;

    bensRoute: string = bensRoute;
    marcasRoute: string = marcasRoute;
    marcasModule: any = marcasModuleName;
    categoriasRoute: string = categoriasRoute;
    categoriasModule: any = categoriasModuleName;

    frotasRoute: string = frotasRoute;
    veiculosRoute: string = veiculosRoute;
    veiculosModule: any = veiculosModuleName;
    aeronavesRoute: string = aeronavesRoute;
    aeronavesModule: any = aeronavesModuleName;
    embarcacoesRoute: string = embarcacoesRoute;
    embarcacoesModule = embarcacoesModuleName;
    equipamentosRoute: string = equipamentosRoute;
    equipamentosModule: any = equipamentosModuleName;
    maquinarioRoute: string = maquinarioRoute;
    maquinarioModule: any = maquinarioModuleName;
    outrosRoute: string = outrosRoute;
    outrosModule: any = outrosModuleName;

    contasRoute: string = contasRoute;
    contasContabeisMedidaRoute: string = contasContabeisRouter;
    contasContabeisModule: any = contasContabeisModuleName;

    almoxarifadoRoute: string = almoxarifadoRoute;
    medidasRoute: string = medidasRouter;
    medidasModule: any = medidasModuleName;
    gruposMateriaisRoute: string = gruposMateriaisRouter;
    gruposMateriaisModule: any = gruposMateriaisModuleName;
    materialRoute: string = materialRouter;
    materiaisModule: any = materialTitle;
    materiaisRoute: string = materiaisRouter;

    constructor(
        private _authService: AuthService,
        private _usuarioService: UsuarioService
    ) { }

    ngOnInit() {
    }

    ngAfterViewInit() {
        const user = this._usuarioService.getSessionStorageLogged();
        if (user) {
            this.user = user;
        }
    }

    clickLogout() {
        this._authService.logout();
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/pages/gestao/gestao.component.ts
 **/